export class Point {
    public x: number;
    public y: number;
    public time: number;
    public constructor(x: number, y: number, time?: number) {
        this.x = x;
        this.y = y;
        this.time = time || new Date().getTime();
    }

    public velocityFrom(start: Point): number {
        return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
    }

    public distanceTo(start: Point): number {
        const power = 2;
        return Math.sqrt(Math.pow(this.x - start.x, power) + Math.pow(this.y - start.y, power));
    }

    public equals(other: Point): boolean {
        return this.x === other.x && this.y === other.y && this.time === other.time;
    }
}
